import APIService from '@/services/APIService.js';

export default {
  getPhpConfig() {
    return APIService.apiCall().get('/serverConfig/getPhpConfig');
  }
};
